

export const config = {
  RZRPAYKEY: process.env.REACT_APP_RZRPAYKEY,
  RZRPAYSECRET: process.env.REACT_APP_RZRPAYSECRET
}